import React, { Component } from "react";
import { NavItem, Nav } from "react-bootstrap";
import {logoutUser} from "../../actions/authActions";
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

class HeaderLinks extends Component {

    constructor(props) {
        super(props);
        this.handleLogout = this.handleLogout.bind(this);
    }

    handleLogout(e) {
        e.preventDefault();
        this.props.logoutUser();
    }

    render() {
    return (
      <div>


        <Nav pullRight>
          <NavItem onClick={this.handleLogout} eventKey={3} href="#">
            Log out
          </NavItem>
        </Nav>
        {/*<Nav pullRight>
          <NavItem href="/updatePassword">
            Update Password
          </NavItem>
        </Nav>*/}
      </div>
    );
  }
}

HeaderLinks.propTypes = {
    logoutUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
};


const mapStateToProps = state => ({
    auth: state.auth,
});

export default connect(mapStateToProps, {logoutUser})(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx